import { useEffect, useState } from "react";
import apiClient from "@/services/apiClient";
import { normalizeMyCoursesPayload } from "../pages/student/myCoursesUtils";

export function useStudentCourses(studentIdOverride = null) {
  const [courses, setCourses] = useState([]);
  const [summary, setSummary] = useState({ totalCourses: 0, inProgressCourses: 0, completedCourses: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchCourses = async () => {
      try {
        setLoading(true);
        setError("");

        const apiBaseUrl = (process.env.REACT_APP_API_URL).replace(/\/$/, "");
        const response = await apiClient.get(`${apiBaseUrl}/StudentCourse/MyCourses`);
        if (!isMounted) return;
        const normalized = normalizeMyCoursesPayload(response.data);
        setCourses(normalized.courses);
        setSummary(normalized.summary);
      } catch (err) {
        console.error("Failed to load my courses", err);
        if (isMounted) {
          setCourses([]);
          setSummary({ totalCourses: 0, inProgressCourses: 0, completedCourses: 0 });
          setError("Unable to load your courses right now.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCourses();

    return () => {
      isMounted = false;
    };
  }, [studentIdOverride]);

  return { courses, summary, loading, error };
}
